<template>
  <v-container fluid pa-0 mt-0 fill-height>
    <v-layout wrap row justify-content-center>
      <rHeader
        v-if="globals"
        :title_first_line="$t(globals.header)"
        :title_second_line="$t(globals.header2)"
        :herb_image="globals.herb"
        :header_image="globals.topimage"
      ></rHeader>
      <v-flex xl12 md12 sm12 xs12 class="p-3">
        <router-link to="/">
          <v-btn block color="info">{{ $t('back_to_homepage') }}</v-btn>
        </router-link>
          <v-flex class="subheading" text-center>
                  {{ stripHtml($t('autoupdate_info'))}}<b class="text-danger"><span id="last_update">{{ new Date().toLocaleTimeString() }}</span></b>
          </v-flex>
        <v-expansion-panel
          expand
          v-model="selected_branches"
          id="expansion-panel"
          v-if="branches"
          multiple
        >
          <v-expansion-panel-content v-for="(branch, index) in branches" :key="branch.id">
            <template v-slot:header>
              <v-layout column>
                <v-flex class="body-2"><strong>{{ stripHtml($t(branch.branch_name)) }}</strong></v-flex>
                <v-flex row v-if="branch.open_counters > -1">
                  <h5>{{ $t('number_of_opened_counters') }}</h5>
                  <b class="text-danger" style="margin-left:0.5em;"> {{ branch.open_counters }}</b>
                </v-flex>
                <v-flex grow class="subheading" v-if="!branch.online">
                  <v-icon color="red">highlight_off</v-icon>
                  <span>{{ stripHtml($t('branch_offline')) }}</span>
                </v-flex>
              </v-layout>
            </template>
            <v-card class="subheading" v-if="branch.online">
              <v-card-text>
                <v-data-table
                  v-if="$vuetify.breakpoint.mdAndUp"
                  :headers="headers(index)"
                  :items="services(index)"
                  hide-actions
                  class="elevation-5"
                >
                    <template v-slot:items="props">
                        <td v-if="props.item.symbol">{{ props.item.symbol }}</td>
                        <td v-if="props.item.name">{{ props.item.name }}</td>
                        <td v-if="props.item.AverageServiceTime_Sec">{{ props.item.AverageServiceTime_Sec }}</td>
                        <td v-if="props.item.AverageWaitingTimeForWalkIn_Sec && props.item.AverageWaitingTimeForWalkIn_Sec != '23:59:59'">{{ props.item.AverageWaitingTimeForWalkIn_Sec }}</td>
                        <td v-if="props.item.AverageWaitingTimeForWalkIn_Sec && props.item.AverageWaitingTimeForWalkIn_Sec == '23:59:59'">{{ '00:00:00' }}</td>
                        <td v-if="props.item.NumberOfWaitingCustomersForWalkIn">{{ props.item.NumberOfWaitingCustomersForWalkIn }}</td>
                        <td v-if="props.item.last_ticket">{{ props.item.last_ticket }}</td>
                    </template>
                </v-data-table>
                <v-card class="subheading" v-if="$vuetify.breakpoint.smAndDown">
                  <v-card-text>
                    <v-layout column wrap v-for="service in services(index)" :key="service.name">
                      <v-flex text-center font-weight-bold>{{ service.name }}</v-flex>
                      <v-flex>
                        <v-layout
                          row
                          wrap
                          bottom-border
                          v-for="header in headers(index)"
                          :key="header.symbol"
                        >
                          <v-flex sm6 xs6>
                            <v-layout column align-space-around justify-center>
                              <v-flex font-weight-bold>{{header.text}}</v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex sm6 xs6>
                            <v-layout column>
                              <v-flex>{{service[header.name]}}</v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      <rFooter :footer_left="$t(globals.footer_left)" :footer_right="$t(globals.footer_right)"></rFooter>
    </v-layout>
  </v-container>
</template>

<script>
import RemoteData from "../mixins/remotedata";
import Utilities from "../mixins/utilities";
export default {
  data: function() {
    return {
      queueInfo: null,
      selected_branches: []
    };
  },
  computed: {
    branches: function() {
      if (this.queueInfo) {
        return this.queueInfo.BRANCHES;
      }
      return null;
    }
  },
  watch: {
    branches: function(value) {
      this.selected_branches = [];
      this.branches.forEach(element => {
        this.selected_branches.push(true);
      });
    }
  },
  methods: {
    headers: function(index) {
      let headers = [];
      if (this.queueInfo && this.branches) {
        let service = this.branches[index].services[0];
        Object.keys(service).forEach(key => {
          headers.push({
            text: this.$t(key),
            align: "left",
            name: key,
            value: key
          });
        });

        return headers;
      }
      return [];
    },
    services: function(index) {
      let services = [];
      if (this.queueInfo && this.branches) {
        this.branches[index].services.forEach(service => {
          let service_temp = {};
          Object.keys(service).forEach(key => {
            if (key == "name") {
              service_temp[key] = this.$t(service[key]);
            } else {
              service_temp[key] = service[key];
            }
          });
          services.push(service_temp);
        });
        return services;
      }
      return [];
    }
  },
  props: ["globals"],
  mixins: [
    RemoteData({
      queueInfo() {
        return [`${env.apiLinks.queueinfo}`, true];
      }
    }),
    Utilities
  ]
};
</script>

<style scoped>
.bottom-border {
  border-bottom: 1px dotted gray;
}
</style>